"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _toolkit = require('@reduxjs/toolkit');

var _array = require('shared/services/array');

var _selectPopulatedBlobjectSubscribers = require('./selectPopulatedBlobjectSubscribers');

const EMPTY_NUMBERS = []

const sameNumbers = (a, b) =>
  a === b || (a.length === b.length && a.every((n, i) => n === b[i]))

// The phone numbers of the conversation's subscribed teams: the numbers the
// backend texts this conversation's patients from. Empty when no subscribed
// team has a number (the backend then falls back to a number the client
// can't see reliably).
 const makeSelectConversationSMSNumbers = () => _toolkit.createSelector.call(void 0, 
  _selectPopulatedBlobjectSubscribers.makeSelectPopulatedBlobjectSubscribers.call(void 0, ),
  ({ teamSubscribersList }) => {
    const numbers = teamSubscribersList.map(t => t.PhoneNumber).filter(_array.truthy)
    return numbers.length ? numbers : EMPTY_NUMBERS
  },
  { memoizeOptions: { resultEqualityCheck: sameNumbers } },
); exports.makeSelectConversationSMSNumbers = makeSelectConversationSMSNumbers
